import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@epicuro-next/platform/tracking';
import { EffectsModule } from '@ngrx/effects';

import { PanelRedirectEffects } from './state/effects/panel-redirect-effects';

@NgModule({
  imports: [
    CommonModule,
    TrackingModule,
    EffectsModule.forFeature([PanelRedirectEffects]),
  ],
})
export class RecommendationPanelsStateModule {}
